import { autoinject } from 'aurelia-framework';
import { RoleEnum } from '../classes/role-enum';
import { OpaGetUserResultUser, UsersClient } from '@dynamik/common/clients/policy-clients';

@autoinject
export class UserContext {
  constructor(private usersClient: UsersClient) { }

  private userPromise: Promise<OpaGetUserResultUser>;

  async get() {
    return this.userPromise ??= this.usersClient.me();
  }

  async isAdmin() {
    return !!(await this.get()).userRoles[RoleEnum.Admin];
  }

  async isBeta() {
    return !!(await this.get()).userRoles[RoleEnum.BetaTest];
  }

  async isCustomerAdmin(companyId: number) {
    // return !!(await this.get()).customerUserRoles[companyId].roles[RoleEnum.CustomerAdmin];
    return !!(await this.get()).customerUserRoles?.[companyId]?.roles?.[RoleEnum.CustomerAdmin];
  }
}
